import { styled } from 'styled-components';

export const ScBonusCardButtons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
  z-index: 1;
`;
